import { FACE_COLORS } from "../../config/platformBrand";
import styles from "./YulqoFace.module.css";

type YulqoFaceProps = {
  color?: string;
  size?: number;
  me?: boolean;
  mood?: "smile" | "flat";
  bob?: boolean;
  delay?: string;
  index?: number;
};

const YulqoFace: React.FC<YulqoFaceProps> = ({
  color,
  size = 34,
  me = false,
  mood = "smile",
  bob = false,
  delay,
  index = 0,
}) => {
  const fill = color ?? FACE_COLORS[index % FACE_COLORS.length];
  const mouth =
    mood === "smile" ? "M11 21c2.6 2.6 7.4 2.6 10 0" : "M12 22h8";

  return (
    <svg
      className={`${styles.face} ${bob ? styles.bob : ""}`}
      width={size}
      height={size * 1.25}
      viewBox="0 0 32 40"
      aria-hidden="true"
      style={delay ? { animationDelay: delay } : undefined}
    >
      <circle cx="16" cy="16" r="15" fill={fill} />
      {me ? (
        <circle
          cx="16"
          cy="16"
          r="15"
          fill="none"
          stroke="#3B2A20"
          strokeWidth="2.5"
        />
      ) : null}
      <circle cx="11.5" cy="14" r="1.8" fill="#3B2A20" />
      <circle cx="20.5" cy="14" r="1.8" fill="#3B2A20" />
      <circle cx="8.5" cy="19" r="2" fill="#fff" opacity=".35" />
      <circle cx="23.5" cy="19" r="2" fill="#fff" opacity=".35" />
      <path
        d={mouth}
        stroke="#3B2A20"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
      {me ? <path d="M16 32l-4 6h8z" fill="#3B2A20" /> : null}
    </svg>
  );
};

export default YulqoFace;
